import { useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import loginApi from "../../../Services/Login";
import settingsApi from "../../../Services/Settings";
import { showSnackbar } from "../../../Redux/SnackBar/actions";
import { showLoader, hideLoader } from "../../../Redux/Loader/actions";
import { setNewSiteLogo } from "../../../Redux/SiteSettings/actions";
import { setNewtimezone, setSystemlatitude, setSystemlongitude } from "../../../Redux/TimeZone/actions";
import { setAuthentication } from "../../../Redux/Authentication/actions";
import "./signinAll.css";
import "../style01.css";
import "../style02.css";
import loginHero from "../../../assets/images/driverwomenblack.jpg";
import logo from "../../../assets/IconMetuaa.png";
import signupHero from "../../../assets/images/driverwomenblack.jpg";
import img1 from "../../../assets/images/img1_metuaa_green.svg";
import img2 from "../../../assets/images/img2_metuaa_green.svg";
import img3 from "../../../assets/images/img3_metuaa_green.svg";
import img4 from "../../../assets/images/img4_metuaa_green.svg";
import img5 from "../../../assets/images/img5_metuaa_green.svg";
import driverHeroPhoto from "../../../assets/images/driverwomenblack.jpg";
import driverRestPhoto1 from "../../../assets/images/blackdriverman.jpg";
import driverTestimonialAvatar from "../../../assets/images/avatar.png";
import safetyPhoto from "../../../assets/images/f4.png";
import economyCar from "../../../assets/images/classique.png";
import standardCar from "../../../assets/images/premium.png";
import priorityCar from "../../../assets/images/gold.png";
import Header from "../../../components/header";
import Footer from "../../../components/footer";

function getStepStatus(currentStep, stepNumber) {
  if (currentStep > stepNumber) {
    return "complete";
  }

  if (currentStep === stepNumber) {
    return "active";
  }

  return "upcoming";
}

function AppleIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M15.8 2.4c-.8.1-1.7.6-2.2 1.3-.5.7-.8 1.6-.7 2.5.8.1 1.7-.4 2.3-1.1.6-.7 1-1.7.6-2.7zM12 7c1.4 0 2.3.8 3.4.8 1.1 0 1.9-.8 3.3-.8 1.2 0 2.7.7 3.5 1.8-1.1.7-2 2.1-2 4 0 2.2 1.5 4.1 2.5 4.7-.7 1.8-2.2 4.1-4.1 4.1-1.1 0-1.6-.7-3-.7s-2 .7-3 .7c-1.9 0-3.6-2.1-4.4-3.9C6 16.9 5 14.9 5 12.6 5 9.3 7 7 9.7 7c1.3 0 2.1.8 2.3.8.2 0 1.2-.8 2.4-.8z" />
    </svg>
  );
}

function PlayIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M3.5 2.9 13.8 12 3.5 21.1V2.9z" />
      <path d="M14.6 11.2 18.9 8.8c1.5-.8 3.1-.2 3.1 1.2 0 .7-.4 1.2-1 1.6l-3.8 2.1-2.6-2.5z" />
      <path d="M14.6 12.8l2.6 2.5 3.8 2.1c.6.3 1 .9 1 1.6 0 1.4-1.6 2-3.1 1.2l-4.3-2.4-1.6-1.5 1.6-1.5z" />
    </svg>
  );
}

function ArrowLeftIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M14.8 4.8 13.4 3.4 5 11.8l8.4 8.4 1.4-1.4-6-6H21v-2H8.8l6-6z" />
    </svg>
  );
}

function ArrowRightIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="m9.2 19.2 1.4 1.4 8.4-8.4-8.4-8.4-1.4 1.4 6 6H3v2h12.2l-6 6z" />
    </svg>
  );
}

function ClockIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm1 10.4 3.2 2-1 1.6-4.2-2.6V6h2v6.4z" />
    </svg>
  );
}

function BoltIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M14 2 5 13h6l-1 9 9-11h-6l1-9z" />
    </svg>
  );
}

function LockIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M17 9h-1V7a4 4 0 0 0-8 0v2H7a2 2 0 0 0-2 2v9h14v-9a2 2 0 0 0-2-2zm-6 0V7a1 1 0 0 1 2 0v2h-2z" />
    </svg>
  );
}

function SparkIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 2.5 9.7 8.3 3.9 10.6l5.8 2.3L12 18.7l2.3-5.8 5.8-2.3-5.8-2.3L12 2.5z" />
    </svg>
  );
}

function ExternalArrowIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M13 5h6v6h-2V8.4l-8.7 8.7-1.4-1.4L15.6 7H13V5z" />
    </svg>
  );
}

const rideCards = [
  {
    id: "economy",
    label: "1 of 3",
    title: "Attendez et économisez",
    image: economyCar,
    icon: ClockIcon,
    points: [
      { icon: ClockIcon, text: "Économique" },
      { icon: LockIcon, text: "Privé" },
    ],
  },
  {
    id: "standard",
    label: "2 of 3",
    title: "Standard",
    image: standardCar,
    icon: BoltIcon,
    points: [
      { icon: BoltIcon, text: "Efficace" },
      { icon: LockIcon, text: "Privé" },
    ],
  },
  {
    id: "priority",
    label: "3 of 3",
    title: "Départ prioritaire",
    image: priorityCar,
    icon: SparkIcon,
    points: [
      { icon: BoltIcon, text: "Efficace" },
      { icon: LockIcon, text: "Privé" },
    ],
  },
];

function StoreBadge({ href, label, sublabel, Icon }) {
  return (
    <a
      className="store-badge"
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label={label}
    >
      <span className="store-badge-icon" aria-hidden="true">
        <Icon />
      </span>
      <span className="store-badge-copy">
        <span>{sublabel}</span>
        <strong>{label}</strong>
      </span>
    </a>
  );
}

function SplitSection({
  className = "",
  reversed = false,
  title,
  text,
  image,
  imageAlt,
  children,
  cta,
  link,
  eyebrow,
}) {
  return (
    <section className={`section ${className}`}>
      <div className="page-shell">
        <div className={`split-layout ${reversed ? "reverse" : ""}`}>
          <div className="split-copy">
            {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
            <h2 className="section-title">{title}</h2>
            <p className="section-copy">{text}</p>
            {cta ? <div className="section-actions">{cta}</div> : null}
            {link ? <div className="section-link-wrap">{link}</div> : null}
          </div>
          <div className="split-media">
            {image ? (
              <img
                className="section-photo"
                src={image}
                alt={imageAlt}
                loading="lazy"
                decoding="async"
              />
            ) : null}
            {children}
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── Icônes SVG ───────────────────────────────────────────────────────────────

const IconLanguage = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 32 32"
    style={{ fill: "currentColor" }}
    aria-hidden="true"
    focusable="false"
  >
    <path d="M15.982 3C8.719 3 4.05 7.7 4.05 14.932c0 3.662 1.16 6.683 3.357 8.82L5.973 29l6.469-2.533c1.13.275 2.35.427 3.57.427 7.263 0 11.932-4.7 11.932-11.932S23.244 3 15.982 3zm0 22.308c-1.251 0-2.624-1.923-3.387-5.036h6.774c-.763 3.113-2.136 5.036-3.387 5.036zm-3.693-6.653a23.424 23.424 0 0 1-.274-3.723c0-1.343.091-2.594.274-3.723h7.385c.184 1.129.275 2.38.275 3.723s-.091 2.594-.275 3.723H12.29zm3.693-14.038c1.251 0 2.624 1.923 3.387 5.036h-6.774c.762-3.113 2.136-5.036 3.387-5.036zm5.31 6.622h4.516c.336 1.068.519 2.32.519 3.723 0 1.404-.183 2.625-.519 3.723h-4.516c.152-1.16.244-2.41.244-3.723 0-1.312-.061-2.563-.244-3.723zm3.875-1.586h-4.15c-.427-1.892-1.068-3.48-1.861-4.639 2.472.61 4.73 2.075 6.011 4.639zM12.808 5.014c-.793 1.16-1.434 2.747-1.861 4.639h-4.15c1.281-2.564 3.54-4.029 6.011-4.639zM6.156 11.24h4.516a28.605 28.605 0 0 0 0 7.446H6.156a13.066 13.066 0 0 1-.52-3.723c0-1.403.184-2.655.52-3.723zm6.164 13.55-3.998 1.556.855-3.113-.366-.335a8.99 8.99 0 0 1-2.015-2.625h4.15c.428 1.892 1.069 3.48 1.862 4.639-.091-.03-.152-.03-.244-.061l-.244-.061zm6.836.122c.793-1.16 1.434-2.747 1.861-4.639h4.15c-1.281 2.533-3.54 3.998-6.011 4.639z" />
  </svg>
);

const IconHamburger = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    style={{ fill: "currentColor" }}
    aria-hidden="true"
    focusable="false"
  >
    <path d="M29 7.75H3v1.989h26V7.75zm0 7.26H3V17h26v-1.99zm0 7.238H3v1.989h26v-1.99z" />
  </svg>
);

const IconArrowRight = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    style={{ fill: "currentColor" }}
    aria-hidden="true"
    focusable="false"
  >
    <path d="M9.652 2.65 8.426 3.876l3.258 3.258H1v1.728h10.684L8.426 12.12l1.226 1.226L15 7.998 9.652 2.65z" />
  </svg>
);

const IconArrowRightLg = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    style={{ fill: "currentColor" }}
    aria-hidden="true"
    focusable="false"
  >
    <path d="m19.157 6.15-1.584 1.608 7.106 7.107H3v2.256h21.679l-7.106 7.13 1.584 1.585L29 15.993 19.157 6.15z" />
  </svg>
);

const IconChevronDown = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    style={{ fill: "currentColor" }}
    aria-hidden="true"
    focusable="false"
  >
    <path d="M7.988 12.11 1 5.098 2.208 3.89l5.78 5.78 5.78-5.78L15 5.098 7.988 12.11z" />
  </svg>
);

const IconPickup = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 32 32"
    style={{ fill: "currentColor" }}
    aria-hidden="true"
    focusable="false"
  >
    <path d="M4.8 25.6h5.9V29h1.7v-5.1H4.8v1.7zM17.5 8C18.9 8 20 6.9 20 5.5S18.9 3 17.5 3 15 4.1 15 5.5 16.1 8 17.5 8z" />
    <path d="M25.3 5.4s-.6 1.2-2.5 2.6c-1.1.8-2.6 1.3-4 1.3h-2.7c-2.2 0-4.2 1.2-5.3 3.1-1.4 2.6-1.9 4.3-1.9 4.4l2.1.5s.4-1.6 1.7-3.9c.4-.7 1-1.3 1.8-1.6V29h2.1v-9.8h1.9V29h2.1V11.2c1.2-.3 2.4-.7 3.4-1.5 2.4-1.7 3.1-3.2 3.2-3.4l-1.9-.9z" />
  </svg>
);

const IconCalendarScheduled = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 32 32"
    style={{ fill: "currentColor" }}
    aria-hidden="true"
    focusable="false"
  >
    <path d="M24.119 5.69V3h-1.594v2.69H9.475V3H7.881v2.69H6.287C4.494 5.69 3 7.084 3 8.977V29h22.713C27.506 29 29 27.506 29 25.713V5.69h-4.881zM6.287 7.284h1.594v2.49h1.594v-2.49h13.05v2.49h1.594v-2.49h3.287v4.682H4.594V8.977c0-.996.797-1.693 1.693-1.693zm19.426 20.122H4.593V13.46h22.813v12.153c0 .996-.797 1.793-1.693 1.793z" />
    <path d="M24.119 20.732h-4.383v4.383h4.383v-4.383z" />
  </svg>
);

const IconPromos = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 32 32"
    style={{ fill: "currentColor" }}
    aria-hidden="true"
    focusable="false"
  >
    <path d="m9.431 19.428-.7-1.259-.7 1.26a8.737 8.737 0 0 1-3.442 3.47l-1.259.671 1.26.7a8.807 8.807 0 0 1 3.47 3.47l.7 1.26.7-1.26a8.807 8.807 0 0 1 3.47-3.47l1.259-.7-1.26-.7a8.631 8.631 0 0 1-3.498-3.442zm-.7 6.465A9.922 9.922 0 0 0 6.438 23.6a9.923 9.923 0 0 0 2.295-2.295 9.926 9.926 0 0 0 2.294 2.295 9.924 9.924 0 0 0-2.294 2.294zm.672-14.805a9.978 9.978 0 0 1 4.03-4.03A10.221 10.221 0 0 1 9.403 3c-.923 1.707-2.35 3.107-4.058 4.058a10.22 10.22 0 0 1 4.058 4.03zm18.22 3.667a19.02 19.02 0 0 1-7.585-7.585l-.7-1.26-.7 1.26a18.674 18.674 0 0 1-7.584 7.585l-1.259.7 1.26.699a19.019 19.019 0 0 1 7.584 7.584l.7 1.26.7-1.26a18.675 18.675 0 0 1 7.584-7.584l1.26-.7-1.26-.7zm-8.284 7.052a20.54 20.54 0 0 0-6.353-6.353 20.541 20.541 0 0 0 6.353-6.353 20.544 20.544 0 0 0 6.353 6.353 20.846 20.846 0 0 0-6.353 6.353z" />
  </svg>
);

const IconRocket = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 32 32"
    style={{ fill: "currentColor" }}
    aria-hidden="true"
    focusable="false"
  >
    <path d="M28.926 3.087S28.14 3 26.943 3c-2.31 0-6.144.327-8.606 2.179a44.097 44.097 0 0 0-6.165 6.732l-.109.152c-.043.044-.065.087-.109.13H9.471a4.119 4.119 0 0 0-2.963 1.243L3 16.965l5.86 1.09 5.033 5.054 1.09 5.882 3.485-3.551a4.209 4.209 0 0 0 1.198-2.941v-2.375a46.317 46.317 0 0 0 7.081-6.47c2.876-3.704 2.179-10.567 2.179-10.567zM6.268 15.963l1.372-1.394a2.627 2.627 0 0 1 1.83-.763h1.373L8.97 16.464l-2.701-.501zm11.808 6.58c0 .675-.261 1.328-.74 1.808l-1.33 1.35-.5-2.636 2.57-1.808v1.285zm7.43-9.892a44.837 44.837 0 0 1-6.34 5.86l-4.489 3.16-4.335-4.38 3.006-4.27a42.042 42.042 0 0 1 6.013-6.579c2.114-1.59 5.665-1.83 7.582-1.83h.458c.043 2.244-.284 5.926-1.896 8.04z" />
    <path d="M23 8.926a2.19 2.19 0 0 0-1.133-.588 2.26 2.26 0 0 0-1.264.13 2.258 2.258 0 0 0-1.35 2.048c0 .436.13.872.37 1.22.24.37.588.654.98.828a2.1 2.1 0 0 0 1.264.13A2.19 2.19 0 0 0 23 12.108l-.087.109c.24-.196.414-.458.566-.741.13-.283.196-.588.218-.893 0-.305-.044-.632-.174-.915A2.866 2.866 0 0 0 23 8.926zM9.427 25.483a9.863 9.863 0 0 1-3.18.37 9.373 9.373 0 0 1 .544-3.725 6.359 6.359 0 0 1 1.481-2.287l-1.83-.349a7.56 7.56 0 0 0-1.176 2.07 11 11 0 0 0-.567 5.098l.066.61.61.087c.457.065.936.087 1.394.087 1.024 0 2.07-.152 3.072-.435a7.986 7.986 0 0 0 2.767-1.438l-.349-1.852c-.697.828-1.7 1.438-2.832 1.764z" />
  </svg>
);

const IconCoupon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 32 32"
    style={{ fill: "currentColor" }}
    aria-hidden="true"
    focusable="false"
  >
    <path d="m28.33 11.98-3.446-2.45-1.27-4.05-4.233.06L15.995 3 12.61 5.54l-4.232-.06-1.27 4.05-3.477 2.45L4.99 16l-1.36 4.02 3.477 2.45 1.27 4.05 4.232-.06L15.995 29l3.386-2.54 4.233.06 1.27-4.05 3.476-2.45L27 16l1.33-4.02zm-1.905 7.406-2.932 2.056-1.058 3.416-3.598-.03-2.872 2.146-2.872-2.146-3.598.03-1.058-3.416-2.933-2.056L6.654 16l-1.15-3.386 2.933-2.056 1.058-3.416 3.598.03 2.902-2.177 2.872 2.147 3.598-.03 1.058 3.416 2.933 2.056-1.15 3.386 1.12 3.416z" />
    <path d="M19.656 10.884 10.89 19.65l1.41 1.411 8.766-8.765-1.411-1.41zm-6.684 3.696c.877 0 1.602-.726 1.602-1.603s-.725-1.603-1.602-1.603c-.877 0-1.602.726-1.602 1.603s.695 1.602 1.602 1.602zm6.046 2.81c-.876 0-1.602.726-1.602 1.603s.726 1.602 1.602 1.602c.877 0 1.603-.725 1.603-1.602 0-.877-.726-1.602-1.603-1.602z" />
  </svg>
);

const IconGrinningFace = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 32 32"
    style={{ fill: "currentColor" }}
    aria-hidden="true"
    focusable="false"
  >
    <path d="M16 3C8.8 3 3 8.8 3 16s5.8 13 13 13 13-5.8 13-13S23.2 3 16 3zm0 24.4C9.7 27.4 4.6 22.3 4.6 16 4.6 9.7 9.7 4.6 16 4.6c6.3 0 11.4 5.1 11.4 11.4 0 6.3-5.1 11.4-11.4 11.4z" />
    <path d="M10.4 18.7c.6 2.6 2.9 4.4 5.6 4.4 2.7 0 4.9-1.8 5.6-4.4l.2-1H10.2l.2 1zm10.8-6.9c-1.3 0-2.4 1.2-2.4 2.7h1.6c0-.6.4-1.1.8-1.1s.8.5.8 1.1h1.6c0-1.5-1.1-2.7-2.4-2.7zm-10.4 1.6c.4 0 .8.5.8 1.1h1.6c0-1.5-1.1-2.7-2.4-2.7-1.3 0-2.4 1.2-2.4 2.7H10c0-.6.4-1.1.8-1.1z" />
  </svg>
);

const IconTwitter = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    style={{ fill: "currentColor" }}
    aria-hidden="true"
    focusable="false"
  >
    <path d="M5.403 13.376c5.283 0 8.172-4.377 8.172-8.173 0-.124 0-.248-.008-.371A5.844 5.844 0 0 0 15 3.345a5.732 5.732 0 0 1-1.65.452 2.882 2.882 0 0 0 1.263-1.589c-.564.335-1.18.57-1.824.697a2.875 2.875 0 0 0-4.895 2.62 8.155 8.155 0 0 1-5.92-3 2.874 2.874 0 0 0 .89 3.833 2.85 2.85 0 0 1-1.304-.36v.037c0 1.368.964 2.545 2.304 2.816a2.868 2.868 0 0 1-1.297.05 2.876 2.876 0 0 0 2.684 1.994A5.763 5.763 0 0 1 1 12.085a8.132 8.132 0 0 0 4.403 1.289" />
  </svg>
);

const IconFacebook = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    style={{ fill: "currentColor" }}
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M15 8a7 7 0 1 0-8.094 6.915v-4.892H5.13V8h1.777V6.458c0-1.755 1.045-2.724 2.644-2.724.766 0 1.567.137 1.567.137v1.723h-.883c-.87 0-1.14.54-1.14 1.093V8h1.941l-.31 2.023H9.094v4.892A7.002 7.002 0 0 0 15 8z"
      clipRule="evenodd"
      fillRule="evenodd"
    />
  </svg>
);

const IconInstagram = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    style={{ fill: "currentColor" }}
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M7.998 4.918a3.08 3.08 0 1 0 0 6.16 3.08 3.08 0 0 0 0-6.16zm0 5.08a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
      clipRule="evenodd"
      fillRule="evenodd"
    />
    <path d="M11.2 5.516a.72.72 0 1 0 0-1.44.72.72 0 0 0 0 1.44z" />
    <path
      d="M7.998 2c-1.629 0-1.833.007-2.473.036-.638.03-1.074.13-1.456.279a2.94 2.94 0 0 0-1.062.692 2.94 2.94 0 0 0-.692 1.062c-.148.382-.25.818-.279 1.456-.03.64-.036.844-.036 2.473 0 1.63.007 1.833.036 2.473.03.639.13 1.075.279 1.456.153.395.358.729.692 1.063.333.333.668.538 1.062.691.382.149.818.25 1.456.28.64.028.844.035 2.473.035 1.63 0 1.833-.007 2.473-.036.639-.029 1.075-.13 1.456-.279a2.939 2.939 0 0 0 1.063-.691c.333-.334.538-.668.691-1.063.149-.381.25-.817.28-1.456.028-.64.035-.844.035-2.473s-.007-1.833-.036-2.473c-.029-.638-.13-1.074-.279-1.456a2.939 2.939 0 0 0-.691-1.062 2.94 2.94 0 0 0-1.063-.692c-.381-.148-.817-.25-1.456-.279C9.831 2.006 9.627 2 7.998 2zm0 1.08c1.602 0 1.791.007 2.424.036.585.026.902.124 1.114.206.28.11.48.239.69.449.21.21.34.41.448.69.082.211.18.529.207 1.113.028.633.034.823.034 2.424 0 1.602-.006 1.791-.034 2.424-.027.585-.125.902-.207 1.114-.109.28-.239.48-.449.69-.21.21-.41.34-.69.448-.21.082-.528.18-1.113.207-.633.028-.822.034-2.424.034-1.602 0-1.791-.006-2.424-.034-.584-.027-.902-.125-1.113-.207a1.858 1.858 0 0 1-.69-.449c-.21-.21-.34-.41-.449-.69-.082-.21-.18-.528-.206-1.113-.03-.633-.035-.822-.035-2.424 0-1.601.006-1.791.035-2.424.026-.584.124-.902.206-1.113.11-.28.239-.48.449-.69.21-.21.41-.34.69-.449.211-.082.529-.18 1.113-.206.633-.03.823-.035 2.424-.035z"
      clipRule="evenodd"
      fillRule="evenodd"
    />
  </svg>
);


function EmailIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <rect x="4" y="6" width="16" height="12" rx="2.5" />
      <path d="m5.5 8 6.5 5 6.5-5" />
    </svg>
  );
}


function ShieldIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 2 4 5v6c0 5 3.4 9.7 8 11 4.6-1.3 8-6 8-11V5l-8-3zm-1 12.6-2.1-2.1 1.4-1.4L11 12.8l2.7-2.7 1.4 1.4-3.1 3.1z" />
    </svg>
  );
}

function CarIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M5.5 13 7 9.2A2.5 2.5 0 0 1 9.3 8h5.4a2.5 2.5 0 0 1 2.3 1.2L18.5 13v5h-1.5a1.5 1.5 0 0 1-3 0H10a1.5 1.5 0 0 1-3 0H5.5v-5zm2.2-1.2h8.6l-1-2.1a.7.7 0 0 0-.6-.3H9.3a.7.7 0 0 0-.6.3l-1 2.1zM8 15.2a1.3 1.3 0 1 0 0 2.6 1.3 1.3 0 0 0 0-2.6zm8 0a1.3 1.3 0 1 0 0 2.6 1.3 1.3 0 0 0 0-2.6z" />
    </svg>
  );
}

function StarIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="m12 3 2.6 5.3L20 9.1l-4 3.9.9 5.6-4.9-2.6-4.9 2.6.9-5.6-4-3.9 5.4-.8L12 3z" />
    </svg>
  );
}

function EyeIcon({ hidden }) {
  if (hidden) {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M12 6.2c4.8 0 8.8 3 10.4 5.8-.5.8-1.2 1.7-2 2.5l1.4 1.4c1.2-1.2 2-2.3 2.7-3.9-.8-1.7-2.1-3.4-3.9-4.8C18.5 5.4 15.4 4.2 12 4.2c-1.2 0-2.4.1-3.5.4l1.7 1.7c.6-.1 1.2-.1 1.8-.1zm-8.1.7 2.2 2.2C4.4 10.2 3 11.9 2 13.8c1.6 3 5.8 7 10 7 1.5 0 2.9-.3 4.1-.8l2.2 2.2 1.4-1.4L5.3 6.2 3.9 6.9zm6.8 6.8 2 2c-.2 0-.5.1-.8.1-2.3 0-4.2-1.9-4.2-4.2 0-.3 0-.6.1-.8l2 2a2.1 2.1 0 0 0 2.9 2.9zM12 8.6c-1.1 0-2.1.4-2.8 1.1l1.4 1.4c.3-.3.8-.5 1.4-.5 1.1 0 2 .9 2 2 0 .6-.2 1.1-.5 1.4l1.4 1.4A4 4 0 0 0 12 8.6z" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 5c-4.7 0-8.7 2.8-10.5 7 1.8 4.2 5.8 7 10.5 7s8.7-2.8 10.5-7C20.7 7.8 16.7 5 12 5zm0 11.4a4.4 4.4 0 1 1 0-8.8 4.4 4.4 0 0 1 0 8.8zm0-2.2a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4z" />
    </svg>
  );
}

function GoogleIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="M20.2 12.2c0-.6-.1-1.1-.2-1.6H12v3h4.7c-.2.8-.7 1.9-1.7 2.6v.1l2.4 1.8.2.1c1.5-1.4 2.6-3.5 2.6-6z"
        fill="#4285F4"
      />
      <path
        d="M12 20c2.2 0 4.1-.7 5.5-2l-2.6-2c-.7.5-1.6.8-2.9.8-2.2 0-4-1.4-4.7-3.4l-.1.1-2.5 2 .1.1A8 8 0 0 0 12 20z"
        fill="#34A853"
      />
      <path
        d="M7.3 13.4c-.1-.5-.2-1-.2-1.4s.1-1 .2-1.5v-.1l-2.6-2-.1.1A8 8 0 0 0 4 12c0 1.3.3 2.5.8 3.6l2.5-2z"
        fill="#FBBC05"
      />
      <path
        d="M12 7.6c1.5 0 2.6.6 3.2 1.2l2.3-2.2C16.1 5.3 14.2 4 12 4a8 8 0 0 0-7.2 4.4l2.5 1.9C8 8.2 9.8 7.6 12 7.6z"
        fill="#EA4335"
      />
    </svg>
  );
}

function FacebookIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <circle cx="12" cy="12" r="10" fill="#1877F2" />
      <path
        fill="#fff"
        d="M13.3 8.5h1.8V6h-2c-2.4 0-3.8 1.5-3.8 3.9v1.5H7v2.7h2.2V18h3v-3.9h2.5l.4-2.7h-2.9v-1.2c0-.8.2-1.7 1.1-1.7Z"
      />
    </svg>
  );
}



function FeatureItem({ icon: Icon, title, text }) {
  return (
    <li className="signin-all-feature">
      <span className="signin-all-feature__icon" aria-hidden="true">
        <Icon />
      </span>
      <div className="signin-all-feature__copy">
        <h3>{title}</h3>
        <p>{text}</p>
      </div>
    </li>
  );
}

function SocialButton({ icon: Icon, children }) {
  return (
    <button type="button" className="signin-all-social-button">
      <span className="signin-all-social-button__icon" aria-hidden="true">
        <Icon />
      </span>
      <span>{children}</span>
    </button>
  );
}

function FooterColumn({ title, links }) {
  return (
    <div className="sc-dOvA-dm gASdYH">
      <div className="sc-eSfNbN gdATaP">
        <h2 data-testid="core-ui-text" className="sc-bmzYkS bmTkUk">
          {title}
        </h2>
      </div>
      <button className="sc-bXWnss dAzuYD core-ui-focus">
        <h2 data-testid="core-ui-text" className="sc-bmzYkS bmTkUk">
          {title}
        </h2>
        <span data-testid="core-ui-icon" className="sc-jEACwC fWFepk">
          <IconChevronDown />
        </span>
      </button>
      <ul className="sc-fLvQuD kmaTJn">
        {links.map((link, i) => (
          <li key={i} className="sc-cRmqLi fvtyuu">
            <a href={link.href} className="sc-dUWDJJ gtZVmu">
              <span data-testid="core-ui-text" className="sc-bmzYkS kfdjbm">
                {link.text}
              </span>
            </a>
          </li>
        ))}
      </ul>
      <div className="sc-aNeao eSwNsk">
        <div
          data-testid="core-ui-horizontal-divider"
          className="sc-iMWBiJ iTMXWV"
        />
      </div>
    </div>
  );
}

const footerDriverLinks = [
  { href: "https://www.lyft.com/drive-with-lyft", text: "Devenir chauffeur" },
  {
    href: "https://www.lyft.com/driver/new-driver-guide",
    text: "Guide du nouveau chauffeur",
  },
  { href: "/driver/pay", text: "Recettes" },
  { href: "/driver/cities", text: "Villes" },
  { href: "https://www.lyft.com/click/dax-help-center", text: "Aide" },
  { href: "/driver/safety", text: "Sécurité" },
  {
    href: "/driver-application-requirements",
    text: "Exigences de candidature",
  },
  { href: "/expressdrive", text: "Conduite Express" },
  { href: "/driver/bonus", text: "Prime" },
  { href: "/driver/rewards", text: "Récompenses Metua'a" },
  { href: "/driver/insurance", text: "Assurance" },
  { href: "/black-car-fleet", text: "Flottes de voitures Noires" },
  { href: "/hub", text: "Blogue du chauffeur" },
  { href: "/driver/beta", text: "Programme bêta" },
];

const footerRiderLinks = [
  { href: "/rider", text: "Inscrivez-vous" },
  {
    href: "https://www.lyft.com/memberships/lyft-pink-all-access-annual/offer-details",
    text: "Metua'a Pink",
  },
  { href: "/rider/cities", text: "Villes" },
  { href: "https://www.lyft.com/click/pax-help-center", text: "Aide" },
  { href: "/rider/safety", text: "Sécurité" },
  { href: "/rider/business", text: "Profil professionnel" },
  { href: "/rider/rewards", text: "Récompenses" },
  { href: "/events", text: "Événements" },
  { href: "/rider/airports", text: "Aéroports" },
  { href: "/gift", text: "Cartes-cadeaux" },
  { href: "/donate", text: "Faire un don" },
];

const footerLyftLinks = [
  { href: "/careers", text: "Carrières" },
  { href: "/lyftup/programs", text: "Metua'aUp" },
  { href: "/business", text: "Entreprises" },
  { href: "/healthcare", text: "Soins de santé" },
  { href: "/bikes", text: "Vélos" },
  { href: "/scooters", text: "Trottinettes" },
  { href: "/autonome", text: "Autonome" },
  { href: "https://ads.lyft.com", text: "Publicités Metua'a" },
  { href: "/lieux-et-evenements", text: "Partenariats avec l'équipe Venue" },
  { href: "/developers", text: "Développeurs" },
  { href: "/blog", text: "Blogue Metua'a" },
  { href: "/press", text: "Médias" },
  {
    href: "https://investor.lyft.com",
    text: "Relations avec les investisseurs",
  },
];


const IconPrivacyChoice = () => (
  <svg height="12px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 14">
    <g fillRule="evenodd" clipRule="evenodd" fill="#fff">
      <path d="M7.4 12.8h6.8l3.1-11.6H7.4C4.2 1.2 1.6 3.8 1.6 7s2.6 5.8 5.8 5.8z" />
    </g>
    <g fillRule="evenodd" clipRule="evenodd" fill="#06f">
      <path d="M22.6 0H7.4c-3.9 0-7 3.1-7 7s3.1 7 7 7h15.2c3.9 0 7-3.1 7-7s-3.2-7-7-7zm-21 7c0-3.2 2.6-5.8 5.8-5.8h9.9l-3.1 11.6H7.4c-3.2 0-5.8-2.6-5.8-5.8z" />
    </g>
    <g fill="#fff">
      <path d="M24.6 4c.2.2.2.6 0 .8L22.5 7l2.2 2.2c.2.2.2.6 0 .8-.2.2-.6.2-.8 0l-2.2-2.2-2.2 2.2c-.2.2-.6.2-.8 0-.2-.2-.2-.6 0-.8L20.8 7l-2.2-2.2c-.2-.2-.2-.6 0-.8.2-.2.6-.2.8 0l2.2 2.2L23.8 4c.2-.2.6-.2.8 0z" />
    </g>
    <g fill="#06f">
      <path d="M12.7 4.1c.2.2.3.6.1.8L8.6 9.8c-.1.1-.2.2-.3.2-.2.1-.5.1-.7-.1L5.4 7.7c-.2-.2-.2-.6 0-.8.2-.2.6-.2.8 0L8 8.6l3.8-4.5c.2-.2.6-.2.9 0z" />
    </g>
  </svg>
);

const getAuthPayload = (responseData) => responseData?.data || responseData || {};

const getAuthToken = (authData) =>
  authData?.accessToken ||
  authData?.token ||
  authData?.tokens?.accessToken ||
  authData?.auth?.accessToken;

const persistAuthSession = (authData) => {
  const token = getAuthToken(authData);

  if (!token) {
    return null;
  }

  const user = authData?.user || {};
  const lewooPayToken = authData?.lewooPay?.token || authData?.lewooPayToken || "";
  const lewooPaySession = authData?.lewooPay?.session || authData?.lewooPaySession || null;

  localStorage.setItem("isAuthenticated", true);
  localStorage.setItem("token", token);
  localStorage.setItem("tokenExpiration", Date.now() + 1 * 24 * 60 * 60 * 1000);
  localStorage.setItem("userid", user?.id || authData?.id || "");
  localStorage.setItem("userType", user?.userType || authData?.userType || "");
  localStorage.setItem("authUser", JSON.stringify(user || {}));

  if (lewooPayToken) {
    localStorage.setItem("lewooPayToken", lewooPayToken);
  } else {
    localStorage.removeItem("lewooPayToken");
  }

  if (lewooPaySession) {
    localStorage.setItem("lewooPaySession", JSON.stringify(lewooPaySession));
  } else {
    localStorage.removeItem("lewooPaySession");
  }

  if (authData?.sub_companyName) {
    localStorage.setItem("subcompany", authData.sub_companyName);
  } else {
    localStorage.removeItem("subcompany");
  }

  return token;
};


export default function SigninAll() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const intl = useIntl();

  const [form, setForm] = useState({ email: "", password: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const getMasterValues = useCallback(() => {
    dispatch(showLoader(intl.formatMessage({ id: "signinAll.loading" })));

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(setNewSiteLogo(res?.data?.data?.siteLogo));
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || intl.formatMessage({ id: "signinAll.toast.fetchFailed" }),
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    settingsApi.getMasterValues().then(onSuccess, onFailure);
  }, [dispatch]);

  const getBusinessValues = useCallback(() => {
    dispatch(showLoader(intl.formatMessage({ id: "signinAll.loading" })));

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(setNewtimezone(res?.data?.data?.timeZone));
        dispatch(setSystemlatitude(res?.data?.data?.latitude));
        dispatch(setSystemlongitude(res?.data?.data?.longitude));
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || intl.formatMessage({ id: "signinAll.toast.fetchFailed" }),
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    settingsApi.getBusinessSettings().then(onSuccess, onFailure);
  }, [dispatch]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setError("");
    dispatch(showLoader(intl.formatMessage({ id: "signinAll.loading" })));

    try {
      const res = await loginApi.login({
        email: form.email,
        password: form.password,
        userType: "ADMIN",
      });

      const authData = getAuthPayload(res?.data);
      const token = persistAuthSession(authData);

      if (!token) {
        throw new Error(intl.formatMessage({ id: "signinAll.errors.tokenMissing" }));
      }

      dispatch(hideLoader());
      dispatch(setAuthentication(authData));
      dispatch(
        showSnackbar({
          message: res?.data?.message || "Logged in successfully",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "success",
        })
      );

      getMasterValues();
      getBusinessValues();
      navigate("/");
    } catch (exception) {
      dispatch(hideLoader());
      const message = exception?.response?.data?.message || intl.formatMessage({ id: "signinAll.errors.generic" });
      setError(message);
      dispatch(
        showSnackbar({
          message,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="signin-all-page" style={{ zoom: 0.82 }}>
            <div id="__next">
        <div className="sc-19804fb5-0 fKeZVt">
          <span
            data-testid="core-ui-theme-provider"
            className="sc-dGCmGc kFXgow"
          >
            {/* ── Skip link ── */}
            <div className="sc-a297abbd-0 hLwNen">
              <span
                data-testid="core-ui-theme-provider"
                className="sc-dGCmGc jYRudL sc-63eb72f4-0 dWpSLp"
              >
                <span
                  data-testid="core-ui-button-wrapper"
                  className="sc-eBMEME eHLGuU"
                >
                  <button
                    data-testid="core-ui-button"
                    type="button"
                    aria-disabled="false"
                    style={{
                      "--padding": "16px",
                      "--min-height": "32px",
                      "--min-width": "100px",
                    }}
                    className="sc-dCFHLb sc-tagGq sc-esYiGF dfkCaR krlRAc HOcMb"
                  >
                    <span className="sc-gmPhUn kESbtj">
                      <span
                        data-testid="multi-line-text-wrap"
                        className="sc-aXZVg kGRXWn"
                      >
                        <span
                          data-testid="icon-button-text"
                          className="sc-bmzYkS cLfdwp"
                        >
                          {intl.formatMessage({ id: "signinAll.skipToMain" })}
                        </span>
                      </span>
                    </span>
                  </button>
                </span>
              </span>
            </div>

            <span
              data-testid="core-ui-theme-provider"
              className="sc-dGCmGc cukWQg"
            >
              {/* ══════════════════ HEADER ══════════════════ */}
              <Header />
      <main className="signin-all-shell">
        <section className="signin-all-card" aria-label={intl.formatMessage({ id: "signinAll.cardAriaLabel" })}>
          <div className="signin-all-column signin-all-column--intro">
            <h1 className="signin-all-title">
              {intl.formatMessage({ id: "signinAll.title" })}
            </h1>
            <p className="signin-all-intro-copy">
              {intl.formatMessage({ id: "signinAll.introCopy" })}
            </p>

            <ul className="signin-all-features">
              <FeatureItem
                icon={CarIcon}
                title={intl.formatMessage({ id: "signupPassenger.feature1.title" })}
                text={intl.formatMessage({ id: "signupPassenger.feature1.text" })}
              />
              <FeatureItem
                icon={ShieldIcon}
                title={intl.formatMessage({ id: "signupPassenger.feature2.title" })}
                text={intl.formatMessage({ id: "signupPassenger.feature2.text" })}
              />
              <FeatureItem
                icon={StarIcon}
                title={intl.formatMessage({ id: "signupPassenger.feature3.title" })}
                text={intl.formatMessage({ id: "signupPassenger.feature3.text" })}
              />
            </ul>
          </div>

          <div className="signin-all-column signin-all-column--form">
            <div className="signin-all-form-head">
              <h2>{intl.formatMessage({ id: "signinAll.formTitle" })}</h2>
              <p>{intl.formatMessage({ id: "signinAll.formSubtitle" })}</p>
            </div>

            <form className="signin-all-form" onSubmit={handleSubmit}>
              <div className="signin-all-field-group">
                <label className="signin-all-label" htmlFor="signin-email">
                  {intl.formatMessage({ id: "signinAll.emailLabel" })}
                </label>
                <div className="signin-all-field">
                  <span className="signin-all-field__icon" aria-hidden="true">
                    <EmailIcon />
                  </span>
                  <input
                    id="signin-email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    placeholder={intl.formatMessage({ id: "signinAll.emailPlaceholder" })}
                    value={form.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="signin-all-field-group">
                <label className="signin-all-label" htmlFor="signin-password">
                  {intl.formatMessage({ id: "signinAll.passwordLabel" })}
                </label>
                <div className="signin-all-field">
                  <span className="signin-all-field__icon" aria-hidden="true">
                    <LockIcon />
                  </span>
                  <input
                    id="signin-password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    autoComplete="current-password"
                    placeholder={intl.formatMessage({ id: "signinAll.passwordPlaceholder" })}
                    value={form.password}
                    onChange={handleChange}
                    required
                  />
                  <button
                    type="button"
                    className="signin-all-field__toggle"
                    onClick={() => setShowPassword((current) => !current)}
                    aria-label={
                      showPassword
                        ? intl.formatMessage({ id: "signupPassenger.password.hide" })
                        : intl.formatMessage({ id: "signupPassenger.password.show" })
                    }
                  >
                    <EyeIcon hidden={!showPassword} />
                  </button>
                </div>
              </div>

              <div className="signin-all-forgot">
                <button type="button">{intl.formatMessage({ id: "signinAll.forgotPassword" })}</button>
              </div>

              {error ? (
                <p className="signin-all-error" role="alert" aria-live="polite">
                  {error}
                </p>
              ) : null}

              <button type="submit" className="signin-all-submit" disabled={isSubmitting}>
                {isSubmitting
                  ? intl.formatMessage({ id: "signinAll.submitting" })
                  : intl.formatMessage({ id: "signinAll.submit" })}
              </button>

              <div className="signin-all-divider">
                <span>{intl.formatMessage({ id: "signinAll.dividerText" })}</span>
              </div>

              <div className="signin-all-social">
                <SocialButton icon={GoogleIcon}>{intl.formatMessage({ id: "signinAll.continueWithGoogle" })}</SocialButton>
                <SocialButton icon={FacebookIcon}>{intl.formatMessage({ id: "signinAll.continueWithFacebook" })}</SocialButton>
              </div>

              <p className="signin-all-signup">
                {intl.formatMessage({ id: "signinAll.noAccount" })}{" "}
                <Link to="/signup-passenger">{intl.formatMessage({ id: "signinAll.signupLink" })}</Link>
              </p>
            </form>
          </div>

          <div className="signin-all-column signin-all-column--visual">
            <div className="signin-all-visual">
              <img
                src={loginHero}
                alt={intl.formatMessage({ id: "signinAll.visualAlt" })}
                loading="eager"
                decoding="async"
              />

              <div className="signin-all-visual__badge" aria-hidden="true">
                <span className="signin-all-visual__badge-icon">
                  <ShieldIcon />
                </span>
                <div className="signin-all-visual__badge-copy">
                  <strong>{intl.formatMessage({ id: "signinAll.trustBadgeTitle" })}</strong>
                  <p>{intl.formatMessage({ id: "signinAll.trustBadgeText" })}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="signin-all-trust" aria-label={intl.formatMessage({ id: "signinAll.trustAriaLabel" })}>
          <span className="signin-all-trust__icon" aria-hidden="true">
            <ShieldIcon />
          </span>
          <div className="signin-all-trust__copy">
            <strong>{intl.formatMessage({ id: "signinAll.trustTitle" })}</strong>
            <p>{intl.formatMessage({ id: "signinAll.trustText" })}</p>
          </div>
        </section>
      </main>
                    {/* ══════════════════ FOOTER ══════════════════ */}
                    <Footer />
            </span>
          </span>
        </div>
      </div>
    </div>
  
  );
}
